var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reportData[_vm.reportStatus](_vm.posterParams),
      expression: "reportData[reportStatus](posterParams)"
    }],
    staticClass: "container",
    class: {
      only_one: _vm.isOnlyOne,
      sk_disabled: _vm.state === _vm.StateDefine.Ended
    },
    on: {
      "click": function click($event) {
        return _vm.clickItem('outer');
      }
    }
  }, [_c('BaseItem', {
    attrs: {
      "item": _vm.item,
      "stopClick": true
    }
  }, [_vm.state !== _vm.StateDefine.Ended ? _c('Icon', {
    attrs: {
      "slot": "icon",
      "type": _vm.isHot ? 'hot' : 'new',
      "text": _vm.isHot ? 'HOT' : 'NEW'
    },
    slot: "icon"
  }) : _vm._e()], 1), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "price_info"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "discount"
  }, [_vm._v("¥"), _c('em', [_vm._v(_vm._s(_vm.item.mpExpansion.seckill_price))])]), _c('del', {
    staticClass: "normal"
  }, [_vm._v("¥" + _vm._s(_vm.item.mpExpansion.original_price))])]), _c('div', {
    staticClass: "count"
  }, [_vm._v("共" + _vm._s(_vm.item.mpExpansion.seckill_count) + "份")])]), _vm.day >= 0 && _vm.second >= 0 && _vm.minute >= 0 ? _c('div', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "distance"
  }, [_vm._v(_vm._s(_vm.state === _vm.StateDefine.Ordering ? '距开始还有' : '距结束还有'))]), _vm.day === 0 ? [_c('span', {}, [_vm._v(_vm._s(_vm.hour) + ":")]), _c('span', {}, [_vm._v(_vm._s(_vm.minute) + ":")]), _c('span', {}, [_vm._v(_vm._s(_vm.second))])] : [_c('span', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm.day))]), _vm._v("天\n      ")]], 2) : _c('div', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "distance"
  }, [_vm._v("已结束")])]), _c('div', {
    staticClass: "bottom",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.clickItem();
      }
    }
  }, [_vm.state === _vm.StateDefine.Ordering ? _c('span', {
    staticClass: "btn",
    class: {
      disabled: _vm.booked
    }
  }, [_vm._v(_vm._s(_vm.booked ? '已预约' : '预约'))]) : _vm.state === _vm.StateDefine.InProgress ? _c('span', {
    staticClass: "btn"
  }, [_vm._v("马上抢")]) : _vm.state === _vm.StateDefine.Ended ? _c('span', {
    staticClass: "btn disabled"
  }, [_vm._v("已抢光")]) : _vm._e()])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };